import AnalyticsIcon from '@material-design-icons/svg/filled/analytics.svg?react';
import { useDappDataOptional } from '../../contexts/DappDataContext';
import { usePageTitle } from '../../hooks/usePageTitle';
import { useOptionalDappContext } from '../DappLayout';
import { DashboardHeader } from './DashboardHeader';

export const DashboardAnalytics = () => {
  const dappId = useOptionalDappContext()?.dappId;
  const { dappData } = useDappDataOptional();
  const dappName = dappData?.dappName || null;

  usePageTitle(
    dappId && dappName
      ? `${dappName} - Analytics | Publishing Portal`
      : 'Analytics | Publishing Portal',
  );

  return (
    <div className="flex flex-col h-full">
      <DashboardHeader
        icon={<AnalyticsIcon className="size-4 fill-white" />}
        title="Analytics"
      />

      <div className="flex-1 bg-[#161717] rounded-b-xl overflow-auto">
        <div className="flex items-center justify-center h-full text-white">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">Analytics Dashboard</h1>
            <p className="text-gray-400">
              View analytics and metrics for your dApps
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
